export default {
  // primaryColor: '#00B96B',
  // linkColor: '',
  // successColor: '',
  // warningColor: '',
  // errorColor: '',
}